import { iframeAutoHeight } from '../../ts/helper';
import {
  userCentricsConsentGiven,
  userCentricsOnUpdate
} from '../basisCookiebot/userCentrics';

export const aBlockEmbed = () => {
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll('[is="block-iframe"]')
  );

  components.forEach((component) => {
    const embedWrapper: HTMLElement | null = component.querySelector('.embed');

    /** Element that tells the user that the consent has to be given for the {@link iframe} to load */
    const consentElement: HTMLElement = component.querySelector(
      '[is="basis-cookie-consent-notice"]'
    );

    /**
     * DSGVO. Embedded content is hidden by default. We need to actively get the users consent.
     */
    const handlePrivacy = () => {
      /**
       * We can show/hide the video based on the users cookie choice
       */
      const handleConsent = () => {
        const update = () => {
          if (userCentricsConsentGiven('marketing')) {
            /** reveal content */
            consentElement.inert = true;
            embedWrapper.inert = false;

            iframeAutoHeight(embedWrapper.querySelector('iframe'));
          } else {
            /** hide content */
            consentElement.inert = false;
            embedWrapper.inert = true;
          }
        };

        update();
        userCentricsOnUpdate(update);
      };

      handleConsent();
    };

    handlePrivacy();
  });
};
